// Vendor imports
const _ = require('lodash')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
const { parseTemplate } = require('shared/model-helpers/meta-template')

function wrapArticle(article, meta) {
  let normalizedArticle = article
  let recReason
  if (article.meta) {
    // The `meta` field is used to convey context and does not
    // represent persisted model data; move it to the streamItem
    // so that the context is retained, but separate from the article
    // See: https://redux.js.org/recipes/structuringreducers/normalizingstateshape
    normalizedArticle = _.clone(article)
    delete normalizedArticle.meta
    // Attach parsed meta-template to rec_reason
    recReason = article.meta['rec_reason']
    recReason = Object.assign({}, recReason, {
      html: parseTemplate(recReason)
    })
  }
  return {
    type: modelTypes.ARTICLE,
    id: article['url_id'],
    article: normalizedArticle,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: meta.urlRecId || meta.recId,
      recReason
    }
  }
}

function wrapCollection(collection, meta) {
  return {
    type: modelTypes.MIX,
    id: collection.id,
    collection,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: meta.mixRecId || meta.recId
    }
  }
}

function wrapInterest(interest, meta) {
  return {
    type: modelTypes.INTEREST,
    id: interest.key,
    interest,
    meta: {
      recId: meta.interestRecId || meta.recId
    }
  }
}

function wrapUser(user, meta) {
  return {
    type: modelTypes.USER,
    id: user.id,
    user,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: meta.userRecId || meta.recId
    }
  }
}

function wrapFeedItem(feedItem, meta = {}) {
  const modelType = feedItem.type
  switch (modelType) {
    case modelTypes.ARTICLE:
      return wrapArticle(feedItem, meta)
    case modelTypes.INTEREST:
      return wrapInterest(feedItem, meta)
    case modelTypes.MIX:
      return wrapCollection(feedItem, meta)
    case modelTypes.USER:
      return wrapUser(feedItem, meta)
    default:
      if (modelType) {
        throw new Error(`Unsupported feedItem.type[${modelType}]`)
      }
      throw new Error(`Missing feedItem.type`)
  }
}

function wrapFeedStream(stream) {
  return {
    items: stream.items.map(item => wrapFeedItem(item, stream.meta)),
    meta: stream.meta || {} // There should always be meta, even if empty
  }
}

module.exports = {
  wrapArticle,
  wrapCollection,
  wrapFeedItem,
  wrapFeedStream
}
